import type { DepositCvusTranslations } from "../interfaces/depositCvus";

export const depositCvusTranslations: DepositCvusTranslations = {
  // Page
  page_title: "CVUs de depósito",
  page_subtitle: "Contas recebedoras para depósitos em pesos argentinos (Argentina)",
  why_banner:
    "Sem um CVU registrado, os depósitos da organização na Argentina não podem ser atribuídos nem creditados.",
  no_org_prompt: "Selecione uma organização para ver seus CVUs.",

  // Org selector
  org_label: "Organização",
  org_placeholder: "Buscar organização…",
  org_loading: "Carregando organizações…",
  org_empty: "Nenhuma organização encontrada.",
  org_error: "Não foi possível carregar as organizações.",
  org_truncated: "Há mais organizações do que as exibidas; refine a busca pelo nome.",

  // List
  list_title: "CVUs registrados",
  filter_placeholder: "Filtrar por CVU ou nota…",
  filter_no_results: "Nenhum CVU corresponde ao filtro.",
  empty_title: "Sem CVUs registrados",
  empty_description:
    "Registre a primeira conta recebedora para habilitar os depósitos desta organização na Argentina.",
  error_load: "Não foi possível carregar os CVUs da organização.",
  error_retry: "Tentar novamente",
  registered_at: "Registrado em",
  note_label: "Nota",
  status_active: "Ativo",
  status_inactive: "Inativo",
  flavor_static: "Estático",
  flavor_dynamic: "Dinâmico",
  copy_aria: "Copiar",
  copy_success: "Copiado para a área de transferência",

  // Register dialog
  button_register: "Registrar CVU",
  dialog_title: "Registrar CVU de depósito",
  dialog_description: "A conta recebedora ficará vinculada à organização selecionada.",
  dialog_org_label: "Organização",
  dialog_account_label: "CVU",
  dialog_account_placeholder: "0000 0031 0001 0000 0000 01",
  dialog_account_helper: "22 dígitos, sem espaços ou hífens.",
  dialog_note_label: "Nota (opcional)",
  dialog_note_placeholder: "ex.: CVU recebedor principal",
  dialog_cancel: "Cancelar",
  dialog_submit: "Registrar",
  validation_account: "O CVU deve ter exatamente 22 dígitos.",
  hint_already_registered: "Este CVU já está registrado para esta organização.",
  toast_registered: "CVU registrado",
  toast_already_registered: "Este CVU já estava registrado para a organização",
  error_cross_org:
    "Este CVU já está atribuído a outra organização. Um CVU só pode estar ativo em uma organização por vez.",
  error_no_write_permission: "Você não tem permissão para registrar CVUs de depósito.",
  error_register: "Não foi possível registrar o CVU.",

  // Detail drawer
  drawer_title: "Detalhe do CVU",
  drawer_section_details: "Detalhes",
  drawer_section_metadata: "Metadados",
  drawer_id: "ID",
  drawer_reference: "Referência",
  drawer_created: "Registrado",
  drawer_updated: "Atualizado",
};
